/**
 * The TokenDetail container
 */
import { estimateRewardsAbi } from "@bkry/bowline-components/Staking";
import { genericAbiRead } from "@bkry/bowline-redux/contracts";
import { useSsrEffect, useSsrState, useRegisterEffect } from "@issr/core";
import { ethers } from "ethers";
import PropTypes from "prop-types";
import React from "react";
import { AiOutlineClockCircle } from "react-icons/ai";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { Button, Input } from "reactstrap";
import { useAccount } from "../../CustomHook";

/**
 * TokenDetail container used as app default landing page
 */
const StakingInfo = (props, context) => {
  const {
    contractAddress,
    tokenId,
    isStaked,
    setSelectTokensMode,
    selectTokensMode,
    selectedTokens,
    addSelectedToken,
    removeSelectedToken,
    stakingContract,
  } = props;
  const dispatch = useDispatch();
  const registerEffect = useRegisterEffect();
  const { account, ethProvider: provider } = useAccount();
  const [estimateRewards, setEstimateRewards] = useSsrState(null);
  const [testInc, setTestInc] = useSsrState(0);
  // Required to force reerendering

  const handleEstimateRewards = async () => {
    registerEffect(
      dispatch,
      genericAbiRead({
        functionAbi: estimateRewardsAbi,
        contractAddress: stakingContract,
        account: account,
        provider: provider,
        functionName: "estimateRewardsForToken",
        genericInputs: {
          nftContractAddress: contractAddress,
          tokenId: tokenId,
        },
        successCallbackFnc: (data) => {
          setEstimateRewards(ethers.utils.formatEther(data));
        },
        errorCallbackFnc: (_data) => {},
      })
    );
  };

  useSsrEffect(() => {
    handleEstimateRewards();
  }, []);

  const isTokenSelected = selectedTokens?.find(
    (token) => token.address === contractAddress && token.identifier === tokenId
  );

  const handleStakeBtnClick = () => {
    if (!selectTokensMode) setSelectTokensMode(isStaked ? "unstake" : "stake");
    if (isTokenSelected) {
      removeSelectedToken(contractAddress, tokenId);
    } else {
      addSelectedToken(contractAddress, tokenId);
    }
    setTestInc(testInc + 1);
  };

  const timeStaked = useSelector(
    (state) => state.tokens.stakedTokens[contractAddress.toLowerCase()]
  );

  return (
    <>
      <div>
        <small className="align-items-center text-muted fw-bold">
          {estimateRewards} $REWARDs / Month
        </small>
        {isStaked &&
          timeStaked &&
          timeStaked[tokenId]?.stakedAt.toNumber() > 0 && (
            <small className="d-block text-dark fw-bold text-muted">
              <AiOutlineClockCircle size={20} className="me-2" />
              {context.t("staked")}
              <Moment fromNow unix className="ms-2">
                {timeStaked ? timeStaked[tokenId]?.stakedAt : null}
              </Moment>
            </small>
          )}
        {!isStaked && <br />}
      </div>
      <div className="my-3 d-grid gap-2 col-sm-12 mx-auto">
        <Button
          className=""
          color="primary"
          outline={isStaked}
          onClick={handleStakeBtnClick}
          disabled={
            (selectTokensMode === "stake" && isStaked) ||
            (selectTokensMode === "unstake" && !isStaked)
          }
        >
          {((selectTokensMode === "unstake" && isStaked) ||
            (selectTokensMode === "stake" && !isStaked)) && (
            <Input
              type="checkbox"
              className="me-2"
              checked={isTokenSelected}
              disabled
            />
          )}
          {isStaked ? context.t("Unstake") : context.t("Stake")}
        </Button>
      </div>
    </>
  );
};

/**  define proptype for the 'translation' function  */
StakingInfo.contextTypes = {
  t: PropTypes.func,
};

StakingInfo.propTypes = {
  tokenId: PropTypes.string.isRequired,
  contractAddress: PropTypes.string,
  isStaked: PropTypes.bool,
  stakeBtnClicked: PropTypes.bool,
  setSelectTokensMode: PropTypes.func,
  selectTokensMode: PropTypes.bool,
  setSelctedTokens: PropTypes.func,
  selectedTokens: PropTypes.array,
  addSelectedToken: PropTypes.func,
  removeSelectedToken: PropTypes.func,
  stakingContract: PropTypes.string,
};

/** export the component as redux connected component */
export default StakingInfo;
